import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface ScheduleActionOptionProps {
  icon: LucideIcon;
  title: string;
  description: string;
  onClick: () => void;
  disabled?: boolean;
  iconClassName?: string;
}

export function ScheduleActionOption({
  icon: Icon,
  title,
  description,
  onClick,
  disabled,
  iconClassName,
}: ScheduleActionOptionProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={cn(
        "group flex w-full items-start gap-3 rounded-md border border-input bg-background p-4 text-left transition-colors",
        "hover:bg-primary hover:text-primary-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:pointer-events-none disabled:opacity-50",
      )}
    >
      <Icon
        className={cn(
          "mt-0.5 h-5 w-5 shrink-0 text-primary group-hover:text-primary-foreground",
          iconClassName,
        )}
      />
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-medium leading-snug">{title}</span>
        <span className="mt-1 block text-xs leading-relaxed text-muted-foreground group-hover:text-primary-foreground/80">
          {description}
        </span>
      </span>
    </button>
  );
}
